import Request, { GET, POST } from '@/utils/request'
import Url from './url'
// import safeHelper from './safeHelper'
// import requestHelper from './requestHelper'
import { safeHelper, IssJsBridge } from '@flashex-fe/iss-fe-utils'
import { getQueryString } from '@/utils/common'
const AesCrypto = safeHelper.AesCrypto

const userAPP = () => {
  if (getQueryString('iss_from') === 'android' && getQueryString('clientid') === 'iss_user_app' && Number((getQueryString('versionName') || '6790').split('.').join('')) >= 6790) {
    let appRes = false
    try {
      appRes = IssJsBridge.call(IssJsBridge.jsBridgeActions.getServerConfig)
      appRes = appRes.data.requestEncryptSwitch
      return appRes
    } catch (error) {
      return false
    }
  } else {
    return false
  }
}
export const submit = async (payload: any) => {
  if (userAPP()) {
    return await POST({
      url: Url.preferSubmit,
      data: AesCrypto.aesEncrypt(JSON.stringify(payload)),
      showError: false,
      isShowStatusError: false,
      headers: {
        encryptSwitch: 'true',
        'Content-Type': 'application/json'
      }
    })
  } else {
    return await POST({
      url: Url.preferSubmit,
      data: payload,
      showError: false
    })
  }
}

export const cities = async (params: any) => {
  return await GET({
    url: Url.cities,
    params,
    showError: false
  })
//   const res = Request({ url: Url.cities, method: 'GET', data })
//   return await res
}

export const sendSmsCode = async (data: any) => {
  if (userAPP()) {
    try {
      return await POST({
        url: Url.sendSmsCode,
        data: AesCrypto.aesEncrypt(data),
        showError: false,
        isShowStatusError: false,
        headers: {
          'Client-Id': 'iss_courier_recommend',
          'Content-Type': 'application/json',
          encryptSwitch: 'true'
        }
      })
    } catch (error) {
      console.error(error, 'sendSmsCodesendSmsCodesendSmsCode')
    }
  } else {
    return await POST({
      url: Url.sendSmsCode,
      data: data,
      showError: false,
      headers: {
        'Client-Id': 'iss_courier_recommend',
        'Content-Type': 'application/json'
      }
    })
  }
}
export const getCodeBySm = async (data: any) => {
  if (userAPP()) {
    try {
      return await POST({
        url: Url.getCodeBySms,
        data: AesCrypto.aesEncrypt(JSON.stringify(data)),
        showError: false,
        isShowStatusError: false,
        headers: {
          'Client-Id': 'iss_courier_recommend',
          'Content-Type': 'application/json',
          encryptSwitch: 'true'
        }
      })
    } catch (error) {
      console.error(error, 'getCodeBySmsgetCodeBySms')
    }
  } else {
    return await POST({
      url: Url.getCodeBySms,
      data: data,
      showError: false,
      headers: {
        'Client-Id': 'iss_courier_recommend',
        'Content-Type': 'application/json'
      }
    })
  }
}
export const courierAge = async (params: any) => {
  return await GET({
    url: Url.courierAge,
    params,
    showError: false
  })
}
